
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./graphql-scala-7-relations.json") })
        }
      }, "path---graphql-scala-7-relations");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---graphql-scala-7-relations!./.cache/json/graphql-scala-7-relations.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---graphql-scala-7-relations!./.cache/json/graphql-scala-7-relations.json
// module chunks = 154